import React from 'react';

import Css from './OptionsTextBox.scss';

const OptionsTextBox = ({ content, button, header, style }) => {
  const Content = content;

  return (
    <div className={Css['text-box']} style={style}>
      <div className={Css.header}>{header}</div>

      <div className={Css.content}>
        <div>
          <Content />
        </div>
        <button onClick={button.click} className={button.classNames}>
          {button.label}
        </button>
      </div>
    </div>
  );
};
export default OptionsTextBox;



// WEBPACK FOOTER //
// ./src/components/SuiteKey/Options/OptionsTextBox.js